// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3z3Vx","filesListContainer":"PosDisputesFiles_filesListContainer__UYsg4","filesButton":"PosDisputesFiles_filesButton__1gxaa"};